const initialState = ()=>({
  screenName: "",
});
const state = initialState();
const getters = {
  screenName: (state) => state.screenName,
};

const mutations = {
  setScreenName(state, payload) {
    state.screenName = payload;
  },
  RESET_STATE(state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
};

const actions = {
  getScreenName({ commit }, payload) {
    const screenName = payload.screenName;
    commit("setScreenName", screenName);
  },
};

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations,
};
